import type { GocertifyScriptProps } from 'components/gocertifyScript/GocertifyScriptContent';

export const formatComponentsGocertifyScriptContent = (
  entryContent: GocertifyScriptProps
) => {
  return {
    type: entryContent.type ?? 'key-worker',
  };
};
